import React, { useEffect } from 'react';

import Container from '../components/Container';
import TableTitle from '../components/TableTitle';
import { useIntegrationsStore } from '../features/integrations/state/use-integrations-store';
import IntegrationBoard from '../features/integrations/IntegrationBoard';
import BtnFilled from '../components/BtnFilled';
import LoadingSpinner from '../components/LoadingSpinner';
import RequestModal from '../features/integrations/RequestModal/Modal';
import IconButton from '@mui/material/IconButton';
import ArchiveIcon from '@mui/icons-material/Archive';
import { useNavigate } from 'react-router-dom';

const Integrations = () => {
  const navigate = useNavigate();

  const { fetchIntegrations, isLoading, data } = useIntegrationsStore();

  useEffect(() => {
    fetchIntegrations();
  }, []);

  return (
    <Container>
      {isLoading ? (
        <LoadingSpinner loading={true} />
      ) : (
        <>
          <div className="flex justify-between items-center flex-wrap gap-2 mb-8">
            <TableTitle title={'В процессе'} />
            <BtnFilled
              btnCb={() => navigate('/archiveIntegrations')}
              title={'Архив передачи показаний'}
              className={'bg-gray-200 text-black hover:bg-gray-300 w-fit hidden sm:block'}
            />
            <IconButton
              onClick={() => navigate('/archiveIntegrations')}
              className="!bg-orange-500 p-1.5"
              sx={{
                display: { sm: 'none' },
              }}>
              <ArchiveIcon className={'text-white'} />
            </IconButton>
          </div>
          <IntegrationBoard integrations={data?.active} emptyText={'Активные интеграции отсутствуют'} />
          <TableTitle title={'Требуют уточнения'} className={'my-8'} />
          <IntegrationBoard integrations={data?.deferred} isDeferred={true} emptyText={'Отложенные интеграции отсутствуют'} />
        </>
      )}
      <RequestModal />
    </Container>
  );
};
export default Integrations;
